export const LANGUAGE = 'language';
export const SHOW_XMAS_OFFER = 'SHOW_XMAS_OFFER';
export const SHOW_SPRING_OFFER = 'SHOW_SPRING_OFFER';
